export default __webpack_public_path__ + "static/media/our-clients.9dd5274c.jpg";